var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8289 2.29177H4.44417C4.32561 2.29177 4.22461 2.19297 4.22461 2.06517C4.22461 1.93736 4.32034 1.83856 4.44417 1.83856H12.8289C12.9474 1.83856 13.0484 1.93736 13.0484 2.06517C13.0484 2.19297 12.9527 2.29177 12.8289 2.29177Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7626 17.2005H0.24886C0.130296 17.2005 0.0292969 17.1017 0.0292969 16.9739V2.06981C0.0292969 1.94744 0.125026 1.8432 0.24886 1.8432H2.76497C2.88353 1.8432 2.98453 1.942 2.98453 2.06981C2.98453 2.19761 2.8888 2.29641 2.76497 2.29641H0.468297V16.7573H16.5475V2.29177H14.5117C14.3931 2.29177 14.2921 2.19297 14.2921 2.06517C14.2921 1.93736 14.3878 1.83856 14.5117 1.83856H16.767C16.8855 1.83856 16.9865 1.93736 16.9865 2.06517V16.9739C16.9821 17.1017 16.8812 17.2005 16.7626 17.2005Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.44282 3.5571H2.76448C2.64592 3.5571 2.54492 3.4583 2.54492 3.3305V0.469874C2.54492 0.347509 2.64065 0.243271 2.76448 0.243271H4.44282C4.56138 0.243271 4.66238 0.34207 4.66238 0.469874V3.3305C4.66238 3.4583 4.56138 3.5571 4.44282 3.5571ZM2.98403 3.10842H4.22853V0.695643H2.98403V3.10842Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5073 3.5571H12.8289C12.7104 3.5571 12.6094 3.4583 12.6094 3.3305V0.469874C12.6094 0.347509 12.7051 0.243271 12.8289 0.243271H14.5073C14.6258 0.243271 14.7268 0.34207 14.7268 0.469874V3.3305C14.7268 3.4583 14.6311 3.5571 14.5073 3.5571ZM13.0485 3.10842H14.293V0.695643H13.0485V3.10842Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7626 5.42156H0.24886C0.130296 5.42156 0.0292969 5.32276 0.0292969 5.19496C0.0292969 5.06715 0.125026 4.96835 0.24886 4.96835H16.7626C16.8812 4.96835 16.9822 5.06715 16.9822 5.19496C16.9822 5.32276 16.8812 5.42156 16.7626 5.42156Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.18239 8.55156H2.37581C2.25725 8.55156 2.15625 8.45276 2.15625 8.32495V6.46044C2.15625 6.33808 2.25198 6.23384 2.37581 6.23384H4.18239C4.30096 6.23384 4.40196 6.33264 4.40196 6.46044V8.32495C4.40196 8.45276 4.30623 8.55156 4.18239 8.55156ZM2.59539 8.10288H3.9681V6.68614H2.59539V8.10288Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66872 8.55156H5.86214C5.74358 8.55156 5.64258 8.45276 5.64258 8.32495V6.46044C5.64258 6.33808 5.73831 6.23384 5.86214 6.23384H7.66872C7.78728 6.23384 7.88828 6.33264 7.88828 6.46044V8.32495C7.88828 8.45276 7.79255 8.55156 7.66872 8.55156ZM6.08171 8.10288H7.45356V6.68614H6.08171V8.10288Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1492 8.55156H9.34261C9.22405 8.55156 9.12305 8.45276 9.12305 8.32495V6.46044C9.12305 6.33808 9.21878 6.23384 9.34261 6.23384H11.1492C11.2678 6.23384 11.3688 6.33264 11.3688 6.46044V8.32495C11.3688 8.45276 11.2678 8.55156 11.1492 8.55156ZM9.56218 8.10288H10.9349V6.68614H9.56218V8.10288Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6355 8.55156H12.8289C12.7104 8.55156 12.6094 8.45276 12.6094 8.32495V6.46044C12.6094 6.33808 12.7051 6.23384 12.8289 6.23384H14.6355C14.7541 6.23384 14.8551 6.33264 14.8551 6.46044V8.32495C14.8551 8.45276 14.7541 8.55156 14.6355 8.55156ZM13.0485 8.10288H14.4204V6.68614H13.0485V8.10288Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.18239 12.2768H2.37581C2.25725 12.2768 2.15625 12.178 2.15625 12.0502V10.1857C2.15625 10.0633 2.25198 9.95908 2.37581 9.95908H4.18239C4.30096 9.95908 4.40196 10.0579 4.40196 10.1857V12.0502C4.40196 12.178 4.30623 12.2768 4.18239 12.2768ZM2.59539 11.8281H3.9681V10.4114H2.59539V11.8281Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66872 12.2768H5.86214C5.74358 12.2768 5.64258 12.178 5.64258 12.0502V10.1857C5.64258 10.0633 5.73831 9.95908 5.86214 9.95908H7.66872C7.78728 9.95908 7.88828 10.0579 7.88828 10.1857V12.0502C7.88828 12.178 7.79255 12.2768 7.66872 12.2768ZM6.08171 11.8281H7.45356V10.4114H6.08171V11.8281Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1492 12.2768H9.34261C9.22405 12.2768 9.12305 12.178 9.12305 12.0502V10.1857C9.12305 10.0633 9.21878 9.95908 9.34261 9.95908H11.1492C11.2678 9.95908 11.3688 10.0579 11.3688 10.1857V12.0502C11.3688 12.178 11.2678 12.2768 11.1492 12.2768ZM9.56218 11.8281H10.9349V10.4114H9.56218V11.8281Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6355 12.2768H12.8289C12.7104 12.2768 12.6094 12.178 12.6094 12.0502V10.1857C12.6094 10.0633 12.7051 9.95908 12.8289 9.95908H14.6355C14.7541 9.95908 14.8551 10.0579 14.8551 10.1857V12.0502C14.8551 12.178 14.7541 12.2768 14.6355 12.2768ZM13.0485 11.8281H14.4204V10.4114H13.0485V11.8281Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.18239 16.0069H2.37581C2.25725 16.0069 2.15625 15.9081 2.15625 15.7803V13.9158C2.15625 13.7934 2.25198 13.6892 2.37581 13.6892H4.18239C4.30096 13.6892 4.40196 13.788 4.40196 13.9158V15.7803C4.40196 15.9026 4.30623 16.0069 4.18239 16.0069ZM2.59539 15.5582H3.9681V14.1415H2.59539V15.5582Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66872 16.0069H5.86214C5.74358 16.0069 5.64258 15.9081 5.64258 15.7803V13.9158C5.64258 13.7934 5.73831 13.6892 5.86214 13.6892H7.66872C7.78728 13.6892 7.88828 13.788 7.88828 13.9158V15.7803C7.88828 15.9026 7.79255 16.0069 7.66872 16.0069ZM6.08171 15.5582H7.45356V14.1415H6.08171V15.5582Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.8e9dbe17e1d63d5fb1dbab11d2f76e60.svg";
export { ForwardRef as ReactComponent };